import React, {ReactNode} from "react";
import {Drawer, IconButton} from "@mui/material";
import {IconMenu} from "bounce-ui/consumer";
import {useConsumerMenu} from "./context/MenuContext";

interface Props {
  children: ReactNode;
}

const ConsumerMenuDrawer = ({children}: Props) => {
  const {open, handleOpen, handleClose} = useConsumerMenu();

  return (
    <>
      <IconButton onClick={handleOpen}>
        <IconMenu />
      </IconButton>
      <Drawer
        anchor="left"
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            sx: {
              width: 360,
              padding: "8px",
            },
          },
        }}
      >
        {children}
      </Drawer>
    </>
  );
};

export default ConsumerMenuDrawer;
